import { IguestbookItem } from '@typings/guestbook/guestbook.interface';
import { fuego } from '@nandorojo/swr-firestore';
import {
  NOTI_TYPE,
  NOTI_TYPE_VALUE,
} from '@typings/notification/notificationType';
import { updateUserNotification } from '../notification/update-notification';
import { addAndGetDocId } from '../timeline/update-timeline';
import {
  getCountFromServer,
  collection,
  query,
  where,
  getFirestore,
} from 'firebase/firestore';

type Props = {
  data: IguestbookItem;
  collectionPath: string;
  docId?: string;
  sendToMasters?: boolean;
  notiType?: NOTI_TYPE_VALUE;
};

export async function updateGuestbook({
  data,
  collectionPath,
  docId,
  notiType,
  sendToMasters = true,
}: Props) {
  const ref = fuego.db.collection(collectionPath);

  let _docId: string | undefined = docId || undefined;

  // numberId는 신규 작성 시에만 계산 (수정 시에는 기존 값 유지)
  let numberId: number | undefined;

  if (!_docId) {
    try {
      const db = getFirestore();
      const postsCountQuery = query(
        collection(db, collectionPath),
        where('createdAt', '>', new Date(0)),
      );
      const countSnap = await getCountFromServer(postsCountQuery);
      numberId = countSnap.data().count + 1;
    } catch {
      // 비인증 사용자의 경우 Firestore 보안 규칙으로 카운트 조회가 실패할 수 있음
      // numberId 없이 게시글 생성을 계속 진행
    }
  }

  const newData: IguestbookItem = {
    ...data,
    editedAt: new Date(),
    ...(numberId !== undefined && { numberId }),
  };

  if (_docId) {
    // 수정
    await ref
      .doc(_docId)
      .set(newData, { merge: true })
      .catch((err) => console.log(err.message));
  }

  if (!_docId) {
    // 추가
    _docId = await addAndGetDocId({ ref, data: newData });

    // docID (parents Doc) 가 없으면, 본인을 추가해줌
    if (_docId) {
      await ref
        .doc(_docId)
        .set({ boardId: _docId }, { merge: true })
        .catch((err) => console.log(err.message));
    }

    // 알림 추가   -----------------------------
    if (_docId) {
      updateUserNotification({
        data: { ...data, boardId: _docId },
        collectionPath,
        notiType: notiType || NOTI_TYPE.GUESTBOOK,
        sendToMasters,
        guestbook: true,
      });
    }
    // --------------------------------------
  }

  return _docId;
}
